import { Grid2, Typography } from '@mui/material';

import { Box } from '@mui/material';
import VaultBox from '../components/about/VaultBox';
import usdcIcon from '../assets/crypto/usdc.svg';
// import usdtIcon from '../assets/crypto/usdt.svg';
// import ethIcon from '../assets/crypto/eth.svg';
// import cbbtcIcon from '../assets/crypto/cbbtc.svg';
// import xaumIcon from '../assets/crypto/xaum.svg';

export default function About() {
  const stepBox1Style = {
    paddingLeft: '2rem',
    position: 'relative'
  };

  return (
    <Box
      width="100%"
      sx={{
        minHeight: '90vh',
        display: 'flex',
        flexDirection: 'column'
      }}
      px={{ xs: 2, sm: 3, md: 4 }}
    >
      <Grid2
        container
        width="100%"
        rowSpacing={{ xs: 2, md: 4 }}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '2rem'
        }}
      >
        <Grid2 size={{ xs: 12, md: 8 }}>
          <Typography
            sx={{
              fontFamily: 'Outfit',
              fontWeight: 600,
              fontSize: { xs: '2rem', md: '2.5rem' },
              lineHeight: 1.25,
              background: 'linear-gradient(0deg, #FFFFFF 0%, #2983E2 200%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              textFillColor: 'transparent',
              my: 4
            }}
          >
            Stone Age Season Deposit Campaign
          </Typography>
        </Grid2>
        <Grid2
          container
          spacing={{ xs: 2, md: 4 }}
          width="100%"
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <Grid2 className="vaults" size={{ xs: 12, md: 5 }}>
            <Box>
              <Box className="step-box" sx={stepBox1Style}>
                <Typography
                  color="rgba(4, 255, 218, 1)"
                  fontWeight={600}
                  fontSize={{ xs: '1.75rem', md: '2.5rem' }}
                  sx={{ mb: 2 }}
                >
                  Supply Relend Network Morpho Vault
                </Typography>
                <Typography fontSize={{ xs: '1.25rem', md: '1.5rem' }} color="white" sx={{ maxWidth: '800px' }}>
                  Deposit into Relend USDC Vault.
                  <br />
                  Earn RELEND units, MORPHO tokens, lending and relending APY.
                </Typography>
                <br />
                <br />
                <br />
                <Typography fontSize={{ xs: '1rem', md: '1.2rem' }} color="white" sx={{ maxWidth: '800px' }}>
                  The Relend USDC vault serves as a Global Price Stability Module, maintaining the peg of all rUSDC
                  instances. Users supply USDC, receiving RELEND units and additional relending yield from rUSDC
                  supplied to partner chains. Collateral markets are selected by risk experts at Relend, B.Protocol and
                  Risk DAO to offer secure and competitive yield.
                </Typography>
              </Box>
              <Typography
                sx={{
                  fontFamily: 'Inter',
                  fontSize: { xs: '0.875rem', sm: '1rem' },
                  fontWeight: 500,
                  lineHeight: 1.5,
                  textAlign: 'left',
                  color: 'white',
                  display: { xs: 'flex', sm: 'none' },
                  mt: 2
                }}
              >
                Note:
              </Typography>
              <Typography
                sx={{
                  fontFamily: 'Inter',
                  fontSize: { xs: '0.875rem', sm: '1rem' },
                  fontWeight: 500,
                  lineHeight: 1.5,
                  textAlign: 'left',
                  color: 'white',
                  maxWidth: '800px',
                  display: { xs: 'flex', sm: 'none' }
                }}
              >
                All deposits go directly into an existing Morpho Vault which is curated by B.Protocol and Relend
                Network. Deposits can be withdrawn at any time/ no lock-up.
              </Typography>
            </Box>
          </Grid2>
          <Grid2 className="leaderboard" size={{ xs: 12, md: 3 }}>
            <Typography sx={{ fontSize: '2rem', fontWeight: 600, color: 'white', mb: 2 }}>Vault</Typography>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                gap: { xs: '2rem', md: '10rem' },
                width: '100%',
                justifyContent: { xs: 'center', md: 'flex-start' }
              }}
            >
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <VaultBox
                  icon={usdcIcon}
                  name="Relend USDC"
                  href="https://app.morpho.org/vault?vault=0x0F359FD18BDa75e9c49bC027E7da59a4b01BF32a&network=mainnet"
                />
                {/* <VaultBox
                  icon={cbbtcIcon}
                  name="Relend cbBTC"
                  href="https://app.morpho.org/vault?vault=0xB9C9158aB81f90996cAD891fFbAdfBaad733c8C6&network=mainnet"
                />
                <VaultBox
                  icon={xaumIcon}
                  name="Relend GOLD"
                  href="https://app.morpho.org/vault?vault=0x45c1875F1C48622b3D9740Af2D7dc62Bc9a72422&network=mainnet"
                />
                <VaultBox
                  icon={usdtIcon}
                  name="Flagship USDT"
                  href="https://app.morpho.org/vault?vault=0x2C25f6C25770fFEC5959D34B94Bf898865e5D6b1&network=mainnet"
                />
                <VaultBox
                  icon={usdcIcon}
                  name="Flagship USDC"
                  href="https://app.morpho.org/vault?vault=0x186514400e52270cef3D80e1c6F8d10A75d47344&network=mainnet"
                />
                <VaultBox
                  icon={ethIcon}
                  name="Flagship ETH"
                  href="https://app.morpho.org/vault?vault=0x38989BBA00BDF8181F4082995b3DEAe96163aC5D&network=mainnet"
                /> */}
              </Box>
            </Box>
          </Grid2>
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 8, md: 8 }}>
          <Box
            sx={{
              maxWidth: '100%',
              mx: 'auto',
              mt: { xs: 2, md: 1 },
              px: { xs: 2, md: 0 }
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Inter',
                fontSize: { xs: '0.875rem', sm: '1rem' },
                fontWeight: 500,
                lineHeight: 1.5,
                textAlign: 'left',
                color: 'white',
                display: { xs: 'none', md: 'flex' }
              }}
            >
              Note:
            </Typography>
            <Typography
              sx={{
                fontFamily: 'Inter',
                fontSize: { xs: '0.875rem', sm: '1rem' },
                fontWeight: 500,
                lineHeight: 1.5,
                textAlign: 'left',
                color: 'white',
                maxWidth: '800px',
                display: { xs: 'none', md: 'flex' }
              }}
            >
              All deposits are directly into existing an Morpho Vault which is curated by B.Protocol and Relend Network.
              Deposits can be withdrawn at any time/ no lock-up.
            </Typography>
          </Box>
        </Grid2>
      </Grid2>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="flex-end"
        sx={{
          mt: 'auto',
          mb: 0
        }}
      >
        <Typography variant="subtitle2" align="center">
          <small>Version: {import.meta.env.VITE_GIT_HASH || 'development'}</small>
        </Typography>
      </Box>
    </Box>
  );
}
